import React, { ReactNode } from 'react';
import { useRouter } from 'next/router';

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const JobSelectorBar = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(4)} 0`,
}));

const SelectStyled = styled(Select)({
  minWidth: '320px',

  '& .MuiSelect-select': {
    border: 'none',
  },
});

const FindButton = styled(Button)`
  min-width: 320px;
`;

export const JobSelector = ({
  locations,
  categories,
  handler,
  selectedCategory,
  selectedLocation,
}: {
  locations: string[];
  categories: string[];
  handler: any;
  selectedCategory: string | undefined;
  selectedLocation: string | undefined;
}): JSX.Element => {
  const router = useRouter();

  const updateQueryParams = (key: string, value: string) => {
    const { query, pathname } = router;
    router.push(
      {
        pathname,
        query: { ...query, [key]: value },
      },
      undefined,
      { shallow: true },
    );
  };

  const handleCategoryChange = (
    event: SelectChangeEvent<unknown>,
    _: ReactNode,
  ) => {
    updateQueryParams('selectedCategory', String(event.target.value));
  };

  const handleLocationChange = (
    event: SelectChangeEvent<unknown>,
    _: ReactNode,
  ) => {
    updateQueryParams('selectedLocation', String(event.target.value));
  };

  return (
    <JobSelectorBar>
      <Grid
        container
        columnSpacing={4}
        alignItems="center"
        justifyContent="center"
        rowSpacing={{ xs: 3, md: 0 }}
      >
        <Grid item>
          <FormControl sx={{ margin: 0 }}>
            <InputLabel id="job-category-select-label">
              Ich suche nach
            </InputLabel>
            <SelectStyled
              labelId="job-category-select-label"
              id="job-category-select"
              value={selectedCategory || ''}
              label="Jobkategorie"
              onChange={handleCategoryChange}
            >
              <MenuItem key="all_cat" value="all">
                Alle Jobkategorien
              </MenuItem>
              {categories.map((category: string) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </SelectStyled>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl sx={{ margin: 0 }}>
            <InputLabel id="job-location-select-label">Jobs in</InputLabel>
            <SelectStyled
              labelId="job-location-select-label"
              id="job-location-select"
              value={selectedLocation || ''}
              label="Jobs in"
              onChange={handleLocationChange}
            >
              <MenuItem key="all_loc" value="all">
                Alle Standorte
              </MenuItem>
              {locations.map((location: string) => (
                <MenuItem key={location} value={location}>
                  {location.split(',')[0]}
                </MenuItem>
              ))}
            </SelectStyled>
          </FormControl>
        </Grid>

        <Grid item>
          <FindButton
            variant="contained"
            color="primary"
            size="medium"
            onClick={handler}
            sx={{ marginTop: 0 }}
          >
            Finde Stellenangebote
          </FindButton>
        </Grid>
      </Grid>
    </JobSelectorBar>
  );
};
